import { useEffect } from "react";

/**
 * The web has no keyboard event, so `--keyboard-h` (keyboardInset.ts, native) stays 0 and a
 * centred panel's foot sits behind a phone's keyboard. While `active`, this measures what the
 * visual viewport lost, so a panel's fixed footer stays above it (card sheet, 2026-10-31).
 */
export function useWebKeyboardHeight(active: boolean): void {
  useEffect(() => {
    const viewport = window.visualViewport;
    if (!active || !viewport) return;
    const root = document.documentElement;
    const measure = () => {
      const lost = Math.max(0, window.innerHeight - viewport.height);
      root.style.setProperty("--keyboard-h", `${Math.round(lost)}px`);
    };
    measure();
    viewport.addEventListener("resize", measure);
    return () => {
      viewport.removeEventListener("resize", measure);
      root.style.removeProperty("--keyboard-h");
    };
  }, [active]);
}
